import { shallowEqual, useSelector } from 'react-redux';

const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
const withHooks = duck => {
  duck.hooks = Object.keys(duck.selectors).reduce((acc, key) => {
    acc[`use${capitalize(key)}Selector`] = () => useSelector(state => duck.selectors[key](state), shallowEqual);
    return acc;
  }, {});
  return duck;
};

export default withHooks;
